import React from 'react';
import FooterInstitute from './FooterInstitute';
function FooterLearn({ className }) {
    return <FooterInstitute className={className} />;
}

export default FooterLearn;
